import type { ReactNode } from 'react'
import { Icon, type IconName } from './Icon'
import { Button } from './Button'

export function Notice({ children, tone = 'error' }: { children: ReactNode; tone?: 'error' | 'success' | 'info' }) {
  return <div className="ui-notice" data-tone={tone} role={tone === 'error' ? 'alert' : 'status'}><Icon name={tone === 'success' ? 'check' : 'warning'} /><div>{children}</div></div>
}
export function LoadingState({ label = 'Cargando…' }: { label?: string }) {
  return <div className="ui-state" role="status"><span className="spinner" /><p>{label}</p></div>
}
export function EmptyState({ title, description, icon = 'box', children }: { title: string; description: string; icon?: IconName; children?: ReactNode }) {
  return <div className="ui-state"><span className="state-icon"><Icon name={icon} size={28} /></span><h2>{title}</h2><p>{description}</p>{children}</div>
}
export function ErrorState({ title = 'No pudimos cargar esta información', retry, busy = false, children }: { title?: string; retry: () => void; busy?: boolean; children?: ReactNode }) {
  return <div className="ui-state"><Notice>{title}. Revisa tu conexión e inténtalo de nuevo.</Notice><Button onClick={retry} busy={busy} emphasis="outline">Reintentar</Button>{children}</div>
}
